const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 544 509",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M139.224,49.426l-34.007,74.802l-54.788,-0c-24.291,-0 -44.279,19.988 -44.279,44.279l0,55.556l14.848,7.409c157.78,78.889 343.874,78.889 501.654,0l14.848,-7.409l0,-55.556c0,-24.291 -19.988,-44.279 -44.279,-44.279l-54.788,-0l-34.007,-74.802c-11.949,-26.306 -38.294,-43.274 -67.186,-43.276l-130.83,0c-28.892,0.002 -55.236,16.97 -67.186,43.276Zm67.186,15.763c-5.775,0.002 -11.041,3.392 -13.431,8.649l-22.907,50.39l203.507,-0l-22.907,-50.39c-2.391,-5.257 -7.657,-8.647 -13.432,-8.649l-130.83,-0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "12.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5,254.805c-74.031,35.134 -154.303,55.232 -236.155,59.127l-0,40.855c-0,16.194 -13.326,29.52 -29.52,29.52c-16.194,-0 -29.519,-13.326 -29.519,-29.52l-0,-40.855c-80.884,-3.867 -161.177,-23.556 -236.156,-59.127l-0,203.301c-0,24.29 19.988,44.279 44.279,44.279l442.792,-0c24.291,-0 44.279,-19.989 44.279,-44.279l0,-203.301Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.5c349ed71ed4eeda82cceb401d19048d.svg";
export { ForwardRef as ReactComponent };